// src/api/favorite.js
import request from '@/utils/request'; // 你的axios封装文件

/**
 * 检查商品是否已收藏
 * @returns {Promise<boolean>} 是否已收藏
 * @param params
 */
export const checkFavorite = (params) => {
  return request({
    url: '/favorite/check',
    method: 'get',
    params
  });
};

/**
 * 批量检查商品是否已收藏
 * @returns {Promise<boolean>} 是否已收藏
 * @param params
 */
export const batchCheckFavorite = (params) => {
  return request({
    url: '/favorite/batchCheck',
    method: 'post',
    data: params
  });
};


/**
 * 添加收藏
 * @param {string} data - 商品数据
 * @returns {Promise<any>} 接口响应
 */
export const addFavorite = (data) => {
  return request({
    url: '/favorite/add',
    method: 'post',
    data
  });
};

/**
 * 取消收藏（删除收藏）
 * @returns {Promise<any>} 接口响应
 * @param data
 */
export const removeFavorite = (data) => {
  return request({
    url: '/favorite/remove',
    method: 'post',
    data
  });
};

/**
 * 获取收藏列表
 * @param {string} [params] - 平台筛选（jd/taobao/pdd）
 * @returns {Promise<any>} 收藏列表数据
 */
export const getFavoriteList = (params) => {
  return request({
    url: '/favorite/list',
    method: 'get',
    params
  });
};

/**
 * 批量添加收藏（游客同步用，可选）
 * @returns {Promise<any>} 接口响应
 * @param data
 */
export const batchAddFavorite = (data) => {
  return request({
    url: '/favorite/batchAdd',
    method: 'post',
    data
  });
};

// 检查单个商品的收藏状态（从数据库）
export const checkFavoriteStatus = (skuId, platform, userId, guestId) => {
  return request({
    url: '/favorite/check',
    method: 'get',
    params: { skuId, platform, userId, guestId }
  })
}

// 同步游客收藏到用户账号
export const syncGuestFavorites = (guestId, userId) => {
  return request({
    url: '/favorite/sync',
    method: 'post',
    data: { guestId, userId }
  })
}
